<div id="main" class="myw-content iom-bgclr d-flex flex-column flex-fill">
  <div class="myw-inner myw-container">
    <div class="position-relative pt-4 mb-4">
      <div class="col-12">
        <div class="row myw-grid">
          <div class="col">
            <form autocomplete="off" *ngIf="isDataAvailable" [formGroup]="textConfigFormStandard"
              (ngSubmit)="CreateDeepdiveStandard()">
              <div class="card iom-card">
                <div class="card-header py-3">
                  <h4 class="card-title">Deepdive Configuration</h4>
                  <a href="javascript:;" (click)="enableAdvanceOption()" class="btn ml-auto btn-secondary" role="button"
                    data-bs-toggle="modal" data-bs-target="#addModal">Advanced Options
                  </a>
                </div>
                <div class="row myw-grid iom-form iom-comPad">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">Deepdive Name</label>
                      <input type="text" formControlName="deepdiveConfig" class="form-control"
                        placeholder="Enter Deepdive Name" />
                    </div>
                  </div>
                  <div class="col-md-5" *ngIf="envVar.EnableLanguage">
                    <div class="form-group  iom-multiselect" [ngClass]="{ disabled: isDisabled == true }">
                      <label class="form-label myw-required">Ticket Language</label>
                      <ng-multiselect-dropdown class="form-control"  style="padding-top: 0px;" [placeholder]="'Select'"
                        [(ngModel)]="selectedStdLanguage" [data]="LanguageList" [settings]="dropdownSettings"
                        (enableCheckAll)="false" (onSelect)="onItemSelect('stdLanguage',$event)"
                        (onSelectAll)="onItemSelectAll('stdLanguage',$event)"
                        (onDeSelect)="onItemDeSelect('stdLanguage',$event)"
                        (onDeSelectAll)="onItemDeSelectAll('stdLanguage',$event)">
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">Classified Based on</label>
                      <a href="javascript:;" class="btn btn-icon"
                        title="Please select an description field having min of 51 tickets with no null values."
                        style="cursor: pointer;">
                        <img src="assets/images/i-icon.svg" alt="Refresh" class="myw-icon myw-18">
                      </a>
                      <select class="form-control" formControlName="ClassifiedBased"
                        (change)="GetQualifiedDescriptionStandalone('NA')">
                        <option value="Select">Select</option>
                        <option *ngFor="let t of lstClassifiedBy" [value]="t.name">
                          {{ t.name }}
                        </option>
                      </select>
                    </div>
                  </div>


                  <div class="col-md-5">
                    <div class="form-group">
                      <div class="form-inline mt-4">
                        <label class="myw-checkbox">
                          <input #DQTcheckboxstd id="DQTcheckbox" type="checkbox" [checked]="EnableDQTStd"
                            (change)="DQTCheckStd(DQTcheckboxstd.checked)" name="data-check">
                          <span>Data Quality Assessment</span>
                        </label>

                        <label class="myw-checkbox">
                          <input #Lemmacheckboxstd id="Lemmacheckbox" type="checkbox" [checked]="EnableLemmaStd"
                            [disabled]="LemmaDisableStd" (change)="LemmaCheckStd(Lemmacheckboxstd.checked)"
                            name="data-check">
                          <span>Lemmatization</span>
                        </label>
                        <label class="myw-checkbox" *ngIf="envVar.Env != 'FDS_ManualUpload'">
                          <input #restrictDDcheckbox id="restrictDDcheckbox" type="checkbox"
                            [checked]="enableRestrictdd" [disabled]="EnableRestrictDDCreation"
                            (change)="RestrictDDCheck(restrictDDcheckbox.checked)" name="data-check">
                          <span>Restrict Infra Deepdive Creation</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-right my-4 d-flex justify-content-end" style="min-height: 0px !important">
                  <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3"
                    (click)="CancelTicketUpload()">
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-primary" style="cursor: pointer; width: 10%">
                    Create
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- modal - Advance Options -->
  <div (click)="HideCheckboxPopup();" class="modal" id="addModal" tabindex="-1" role="dialog"
    aria-labelledby="addInsights" aria-hidden="true" data-bs-backdrop="static">
    <div class="
        modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable
      " role="document">
      <div class="modal-content iom-modewhite iom-modal-newcnt">
        <div class="modal-header border-0">
          <h5 class="modal-title" id="addInsights">Advanced Options</h5>
          <button id="btnAdvanceClose" type="button" data-bs-dismiss="modal" hidden></button>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div *ngIf="isAvanced" class="validate-section">
            <div class="row">
              <div class="col">
                <div *ngIf="categorisedBy" class="form-group">
                  <label class="form-label myw-required mb-3">Select Ticket Field for mapping the domain</label>
                  <select class="form-control control-border" [(ngModel)]="SelectedMapping"
                    (change)="LoadMappingData()">
                    <option>Select</option>
                    <option *ngFor="let filter of categorisedBy">
                      {{ filter.Key }}
                    </option>
                  </select>
                </div>
              </div>
              <div [ngClass]="{ 'd-none': !displayMappingTable }" class="col-12">
                <!-- <div class="dis-table imo-table mt-3"> -->
                <div class="dis-table mt-3">
                  <div class="
                      d-flex
                      align-items-center
                      justify-content-between
                      mb-3
                    ">
                    <h2 class="fs-18 mb-0">Configure Domain Mapping</h2>
                    <div class="myw-search">
                      <input type="text" id="txtSearch" (keyup)="searchDomainMapping($event.target.value)"
                        class="form-control control-border" placeholder="{{ 'Search ' + SelectedMapping }}" />
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-striped table-fixed">
                      <thead>
                        <tr>
                          <th scope="col">{{ SelectedMapping }}</th>
                          <th scope="col" class="text-center">
                            <label class="myw-checkbox myw-radio myw-inline">
                              <input type="radio" name="ag-option" (change)="OnDomainChange(null, 'AO', true)"
                                [checked]="all_AO" />
                              <span>APP</span>
                            </label>
                          </th>
                          <th scope="col" class="text-center">
                            <label class="myw-checkbox myw-radio myw-inline">
                              <input type="radio" name="ag-option" (change)="OnDomainChange(null, 'IO', true)"
                                [checked]="all_IO" />
                              <span>INFRA</span>
                            </label>
                          </th>
                          <th scope="col" class="text-center">
                            <label class="myw-checkbox myw-radio myw-inline">
                              <input type="radio" name="ag-option" (change)="OnDomainChange(null, 'Others', true)"
                                [checked]="all_Others" />
                              <span>OTHERS</span>
                            </label>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let m of MappingFilterData">
                          <td scope="row">{{ m.FieldValue }}</td>
                          <td class="text-center">
                            <label class="myw-checkbox myw-radio myw-inline">
                              <input type="radio" [name]="m.FieldValue" (change)="OnDomainChange(m, 'AO', false)"
                                [checked]="m.IsAO" />
                              <span></span>
                            </label>
                          </td>
                          <td class="text-center">
                            <label class="myw-checkbox myw-radio myw-inline">
                              <input type="radio" [name]="m.FieldValue" (change)="OnDomainChange(m, 'IO', false)"
                                [checked]="m.IsIO" />
                              <span></span>
                            </label>
                          </td>
                          <td class="text-center">
                            <label class="myw-checkbox myw-radio myw-inline">
                              <input type="radio" [name]="m.FieldValue" (change)="OnDomainChange(m, 'Others', false)"
                                [checked]="m.IsOthers" />
                              <span></span>
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="text-right mt-4">
                    <a href="javascript:;" (click)="clickNext()" class="btn btn-primary advance-optnext"
                      style="width: 7 rem">Next</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="isAvanced1" class="iom-section-bdy select-domain">
            <form autocomplete="off" *ngIf="isDataAvailable" [formGroup]="textConfigForm" (ngSubmit)="CreateDeepdive()">
              <div class="modal-body">
                <div class="iom-section-bdy">
                  <div class="form-group mb-3">
                    <label class="form-label fs-16">Select Domain</label>
                    <div class="form-inline mt-3 domain-check" formArrayName="domainOption">
                      <label class="myw-checkbox mr-5" *ngFor="
                          let option of textConfigForm.get('domainOption')[
                            'controls'
                          ];
                          let i = index
                        ">
                        <input type="checkbox" (change)="SelectDoamin()" value="lstDomainOption[i].name"
                          [formControlName]="i" />
                        <span class="apps-check fs-16" *ngIf="lstDomainOption[i].name == 'AO'"
                          title="{{ lstDomainOption[i].msg }}">APP</span>
                        <span class="infra-check fs-16" *ngIf="lstDomainOption[i].name == 'IO'"
                          title="{{ lstDomainOption[i].msg }}">INFRA</span>
                        <span class="other-check fs-16" *ngIf="lstDomainOption[i].name == 'Others'"
                          title="{{ lstDomainOption[i].msg }}">OTHERS</span>
                      </label>
                      <!-- <label class="myw-checkbox">
                                <input type="checkbox" name="domain-option" checked />
                                <span>IO</span>
                            </label>
                            <label class="myw-checkbox">
                                <input type="checkbox" name="domain-option" />
                                <span>Others</span>
                            </label> -->
                    </div>
                  </div>
                  <div class="nav nav-pills iom-tabs" role="tablist">
                    <a *ngIf="enableAo" (click)="loadAoPill()" [ngClass]="{ active: isLoadAoPill }"
                      style="cursor: pointer" class="nav-item nav-link active" id="ao-tab" role="tab"
                      data-bs-toggle="tab" aria-controls="ao" aria-selected="true">APP</a>
                    <a *ngIf="enableIo" (click)="loadIoPill()" [ngClass]="{ active: isLoadIoPill }"
                      style="cursor: pointer" class="nav-item nav-link" id="io-tab" role="tab" data-bs-toggle="tab"
                      aria-controls="io" aria-selected="false">INFRA</a>
                    <a *ngIf="enableOthers" (click)="loadOtherPill()" [ngClass]="{ active: isLoadOtherPill }"
                      style="cursor: pointer" class="nav-item nav-link" id="other-tab" role="tab" data-bs-toggle="tab"
                      aria-controls="other" aria-selected="false">OTHERS</a>
                  </div>
                  <div class="tab-content iom-tab-content">
                    <!-- AO -->
                    <div formGroupName="AOGroup" class="tab-pane show active" id="apps" role="tabpanel"
                      aria-labelledby="apps-tab" [ngClass]="{ active: isLoadAoPill }">
                      <div class="row iom-form">
                        <div class="col-md-5">
                          <div class="form-group">
                            <label class="form-label myw-required">Deepdive Name</label>
                            <input type="text" formControlName="deepdiveConfig" class="form-control"
                              placeholder="Enter Deepdive Name" />
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2">
                          <div class="form-group">
                            <label class="form-label myw-required">Ticket Type</label>
                            <select class="form-control" formControlName="ticketType"
                              (change)="getStopKeyWords('AO', $event, true)">
                              <option value="Select">Select</option>
                              <option *ngFor="let t of lstTicketType_ao" [value]="t.TicketType">
                                {{ t.TicketType }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-5 iom-datepicker">
                          <div class="form-group">
                            <label class="form-label myw-required">Start Date</label>
                            <div class="input-group">
                              <input type="text" formControlName="startDate" class="form-control"
                                placeholder="Select Date" ngbDatepicker #d1="ngbDatepicker" onkeydown="return false"
                                (keyup.backspace)="onDateSelected('AO', $event)"
                                (dateSelect)="onDateSelected('AO', $event)" />
                              <div class="input-group-append">
                                <button (click)="d1.toggle()" class="btn" type="button">
                                  <img src="assets/images/cal.svg" alt="" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2 iom-datepicker">
                          <div class="form-group">
                            <label class="form-label myw-required">End Date</label>
                            <div class="input-group">
                              <input type="text" formControlName="endDate" class="form-control"
                                placeholder="Select Date" ngbDatepicker #d2="ngbDatepicker" onkeydown="return false"
                                (keyup.backspace)="onDateSelected('AO', $event)"
                                (dateSelect)="onDateSelected('AO', $event)" />
                              <div class="input-group-append">
                                <button (click)="d2.toggle()" class="btn" type="button">
                                  <img src="assets/images/cal.svg" alt="" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5">
                          <div class="form-group">
                            <label class="form-label myw-required">Select
                              {{ lstMappingConfig_ao.FilterName }}
                            </label>
                            <div class="iom-dropdown dropdown dropflat newao">
                              <a href="javascript:;" (click)="ShowCheckboxPopup('ao');" class="iom-dropdown-toggle"
                                role="button" title="{{ selectedSupportGroup_AO }}" id="assignmentGroup"
                                data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                                aria-expanded="false">
                                <div style="
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    color: #495057;
                                  ">
                                  {{ selectedSupportGroup_AO }}
                                </div>
                              </a>
                              <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                                <div class="new">
                                  <div class="dropdown-body">
                                    <div class="
                                      d-flex
                                      justify-content-end
                                      iom-dropdown-search
                                    ">
                                      <div class="text-right mt-4">
                                        <a href="javascript:;" (click)="loadSupportGrpName('ao')"
                                          class="btn btn-primary supportgrp-optnext" style="width: 7 rem">Select {{
                                          lstMappingConfig_ao.FilterName }}</a>
                                      </div>
                                    </div>
                                    <div class="iom-dropdown-scroll">
                                      <div *ngIf="aoArr" class="
                                        row
                                        myw-grid
                                        row-cols-2 row-cols-lg-2
                                      ">
                                        <ng-container *ngFor="
                                          let d of aoArr;       
                                          let i = index                                                                         
                                        ">
                                          <div class="col" formArrayName="mappingConfigs" *ngIf="d.name != 'All'">
                                            <label class="my-width" title="{{d.fullName}}">
                                              <span>• {{ d.name }}</span>
                                            </label>
                                          </div>
                                        </ng-container>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2">
                          <div [ngClass]="{ disabled: !categorizedByFlag_ao }" class="form-group">
                            <label class="form-label">Categorised by</label>
                            <select class="form-control" formControlName="categorisedBy">
                              <option value="">Select</option>
                              <option *ngFor="let t of lstCategorisedBy_ao" [value]="t.name">
                                {{ t.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-5" *ngIf="envVar.EnableLanguage">
                          <div class="form-group iom-multiselect" [ngClass]="{ disabled: isDisabled == true }">
                            <label class="form-label myw-required">Ticket Language</label>
                            <ng-multiselect-dropdown formControlName="ddlMultiselect" class="form-control"
                              [placeholder]="'Select'" [(ngModel)]="selectedLanguage_AO" [data]="LanguageList"
                              [settings]="dropdownSettings" (enableCheckAll)="false"
                              (onSelect)="onItemSelect('LanguageAO',$event)"
                              (onSelectAll)="onItemSelectAll('LanguageAO',$event)"
                              (onDeSelect)="onItemDeSelect('LanguageAO',$event)"
                              (onDeSelectAll)="onItemDeSelectAll('LanguageAO',$event)">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2">
                          <div class="form-group">
                            <label class="myw-checkbox">
                              <input #DQTCheckboxAO id="DQTcheckboxAO" type="checkbox" [checked]="EnableDQTAO"
                                (change)="DQTCheckAdv(DQTCheckboxAO.checked,'AO')" name="data-qa">
                              <span>Data Quality Assessment</span>
                            </label>

                            <label class="myw-checkbox">
                              <input #LemmaCheckboxAO id="LemmaCheckboxAO" type="checkbox" [checked]="EnableLemmaAO"
                                [disabled]="LemmaDisableAO" (change)="LemmaCheckAdv(LemmaCheckboxAO.checked,'AO')"
                                name="data-qa">
                              <span>Lemmatization</span>
                            </label>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label class="form-label">Select Algorithm Model</label>
                            <div class="form-inline mt-2">
                              <label class="myw-checkbox myw-radio">
                                <input (click)="
                                    algorithmChange(
                                      true,
                                      'ao',
                                      false,
                                      true,
                                      true,
                                      ''
                                    )
                                  " type="radio" value="2" formControlName="algorithmModel" checked />
                                <span>Auto Categorization (K-means)</span>
                              </label>
                              <label class="myw-checkbox myw-radio">
                                <input (click)="
                                    algorithmChange(
                                      false,
                                      'ao',
                                      true,
                                      true,
                                      true,
                                      ''
                                    )
                                  " type="radio" value="1" formControlName="algorithmModel" />
                                <span>User Defined (N-gram)</span>
                              </label>
                              <!-- <label class="myw-checkbox myw-radio">
                                                                <input
                                                                    (click)="algorithmChange(false,'ao', false, true, true)"
                                                                    type="radio" value="4"
                                                                    formControlName="algorithmModel" />
                                                                <span>SAP Classification</span>
                                                            </label> -->
                            </div>
                          </div>
                        </div>
                        <div [ngClass]="{ disabled: !selectedAlgoOption }" *ngIf="this.required_ao == false"
                          class="col-md-5">
                          <div class="form-group">
                            <label class="form-label">No of Cluster</label>
                            <input type="text" [readonly]="!selectedAlgoOption" formControlName="noOfCluster"
                              class="form-control" placeholder="Enter the Number of Cluster" />
                          </div>
                        </div>
                        <div [ngClass]="{ disabled: !selectedAlgoOption }" *ngIf="this.required_ao == true"
                          class="col-md-5">
                          <div class="form-group">
                            <label class="form-label myw-required">No of Cluster</label>
                            <input type="text" [readonly]="!selectedAlgoOption" formControlName="noOfCluster"
                              class="form-control" placeholder="Enter the Number of Cluster" />
                          </div>
                        </div>
                        <!-- <div *ngIf="userType == 2"
                                                    class="col-md-5 offset-md-2">
                                                    <div [ngClass]="{'disabled':!selectedAlgoOption}" class="form-group">
                                                        <label class="form-label myw-required">Exit Criteria</label>
                                                        <input type="text" [readonly]="!selectedAlgoOption"
                                                            formControlName="exitCriteria" class="form-control"
                                                            placeholder="Enter the number of exit criteria" />
                                                    </div>
                                                </div> -->
                        <div [ngClass]="{ disabled: !selectedAlgoOption }" *ngIf="this.required_ao == false"
                          class="col-md-5 offset-md-2" style="padding-left: 0px">
                          <div class="form-group">
                            <label class="form-label" style="width: 25rem">Allow max % of unclassified tickets</label>
                            <input type="text" [readonly]="!selectedAlgoOption" formControlName="exitCriteria"
                              class="form-control" placeholder="Enter allow max % of unclassified tickets" />
                          </div>
                        </div>
                        <div [ngClass]="{ disabled: !selectedAlgoOption }" *ngIf="this.required_ao == true"
                          class="col-md-5 offset-md-2" style="padding-left: 0px">
                          <div class="form-group">
                            <label class="form-label myw-required" style="width: 25rem">Allow max % of unclassified
                              tickets</label>
                            <input type="text" [readonly]="!selectedAlgoOption" formControlName="exitCriteria"
                              class="form-control" placeholder="Enter allow max % of unclassified tickets" />
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label class="form-label myw-required">Classified Based on</label>
                            <a href="javascript:;" class="btn btn-icon"
                              title="Please select an description field having min of 51 tickets with no null values."
                              style="cursor: pointer;">
                              <img src="assets/images/i-icon.svg" alt="Refresh" class="myw-icon myw-18">
                            </a>
                            <div class="form-inline mt-2">
                              <select class="form-control" formControlName="ClassifiedBased"
                                (change)="GetQualifiedDescriptionStandalone('AO')">
                                <option value="Select">Select</option>
                                <option *ngFor="let t of lstClassifiedBy_ao" [value]="t.name">
                                  {{ t.name }}
                                </option>
                              </select>
                              <!-- <label class="myw-checkbox myw-radio">
                                <input (click)="
                                    ClassifiedBasedONChange(
                                      'ShortDescription',
                                      'AO'
                                    )
                                  " type="radio" value="ShortDescription" formControlName="classifiedBasedOn"
                                  checked />
                                <span>Short Description</span>
                              </label>
                              <label class="myw-checkbox myw-radio">
                                <input [attr.disabled]="
                                    !isResolutionDescEnabled_AO
                                      ? 'disabled'
                                      : null
                                  " (click)="
                                    ClassifiedBasedONChange(
                                      'ResolutionDescription',
                                      'AO'
                                    )
                                  " type="radio" value="ResolutionDescription" formControlName="classifiedBasedOn" />
                                <span>Resolution Description</span>
                              </label> -->
                              <div class="d-flex align-items-end ml-lg-auto mb-2">
                                Click here to&nbsp;<a href="javascript:;" (click)="getTopKeyWords('AO', true)"
                                  title="Get top keywords">
                                  Get top keywords</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="ChartData_AO" class="col-12">
                          <div class="iom-keyword">
                            <div class="
                                d-flex
                                align-items-end
                                justify-content-end
                                align-items-center
                              ">
                              <div class="form-inline mr-2">
                                <select class="form-control control-border" (change)="getTopKeyWords('AO', false)"
                                  formControlName="topWordOption">
                                  <option *ngFor="let t of WordCloudFilterOptions" [value]="t">
                                    Top {{ t }} words
                                  </option>
                                </select>
                              </div>
                              <!-- <a href="javascript:;" title="Minus"><img src="images/key-minus.svg" alt="Minus" class="myw-icon myw-40 mr-n2"></a>
                                                                <a href="javascript:;" title="Plus"><img src="images/key-plus.svg" alt="Plus" class="myw-icon myw-40"></a> -->
                            </div>
                            <div class="card-body" id="wordcloudContent">
                              <div id="containerwordCloud_AO">
                                <app-word-chart [ContainerId]="containerwordCloud_AO" [GraphData]="ChartData_AO"
                                  [wordlength]="1"></app-word-chart>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col" *ngIf="isAddkeywordsEnabled_AO">
                          <div class="form-group">
                            <label class="form-label">Add/Delete Stopwords</label>
                            <div class="form-group iom-multiselect">
                              <label>Language : </label>
                              <select class="form-control" style="width: 200px" [(ngModel)]='selectedStdLanguageAO'
                                formControlName="ignorekeywordLanguage" (change)="GetSelectedLanguage($event,'ao')">
                                <option value="Select">Select</option>
                                <option *ngFor="let t of selectedLanguage_AO" [value]="t">
                                  {{t}}</option>
                              </select>
                            </div>
                            <input type="text" formControlName="ignorekeyword" class="form-control" name="ignoreword"
                              placeholder="Enter Keyword" />
                          </div>
                        </div>
                        <div class="col-auto d-flex align-items-end" *ngIf="isAddkeywordsEnabled_AO">
                          <div class="form-group">
                            <button type="button" (click)="addIgnoreKeyword('ao')" class="btn btn-primary">
                              Add
                            </button>
                          </div>
                        </div>
                        <div class="col-12" *ngIf="isAddkeywordsEnabled_AO && enableBox_AO">
                          <div class="form-group mb-0">
                            <div rows="4">
                              <span class="tag-item" *ngFor="let word of lstIgnoreKeys" name="tagKey">
                                {{ word }}
                                <span class="remove-tag" (click)="RemoveKeyword(word, 'ao')"
                                  style="cursor: pointer">×</span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- IO -->
                    <div formGroupName="IOGroup" class="tab-pane" id="infra" role="tabpanel" aria-labelledby="infra-tab"
                      [ngClass]="{ active: isLoadIoPill }">
                      <div class="row iom-form">
                        <div class="col-md-5">
                          <div class="form-group">
                            <label class="form-label myw-required">Deepdive Name</label>
                            <input type="text" formControlName="deepdiveConfig" class="form-control"
                              placeholder="Enter Deepdive Name" />
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2">
                          <div class="form-group">
                            <label class="form-label myw-required">Ticket Type</label>
                            <select class="form-control" formControlName="ticketType"
                              (change)="getStopKeyWords('IO', $event, true)">
                              <option value="Select">Select</option>
                              <option *ngFor="let t of lstTicketType_io" [value]="t.TicketType">
                                {{ t.TicketType }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-5 iom-datepicker">
                          <div class="form-group">
                            <label class="form-label myw-required">Start Date</label>
                            <div class="input-group">
                              <input type="text" formControlName="startDate" class="form-control"
                                placeholder="Select Date" ngbDatepicker #d3="ngbDatepicker" onkeydown="return false"
                                (keyup.backspace)="onDateSelected('IO', $event)"
                                (dateSelect)="onDateSelected('IO', $event)" />
                              <div class="input-group-append">
                                <button (click)="d3.toggle()" class="btn" type="button">
                                  <img src="assets/images/cal.svg" alt="" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2 iom-datepicker">
                          <div class="form-group">
                            <label class="form-label myw-required">End Date</label>
                            <div class="input-group">
                              <input type="text" formControlName="endDate" class="form-control"
                                placeholder="Select Date" ngbDatepicker #d4="ngbDatepicker" onkeydown="return false"
                                (keyup.backspace)="onDateSelected('IO', $event)"
                                (dateSelect)="onDateSelected('IO', $event)" />
                              <div class="input-group-append">
                                <button (click)="d4.toggle()" class="btn" type="button">
                                  <img src="assets/images/cal.svg" alt="" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5">
                          <div class="form-group">
                            <label class="form-label myw-required">Select
                              {{ lstMappingConfig_io.FilterName }}</label>
                            <div class="iom-dropdown dropdown dropflat newio">
                              <a href="javascript:;" (click)="ShowCheckboxPopup('io');" class="iom-dropdown-toggle"
                                role="button" title=" {{ selectedSupportGroup_IO }}" id="assignmentGroup"
                                data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                                aria-expanded="false">
                                <div style="
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    color: #495057;
                                  ">
                                  {{ selectedSupportGroup_IO }}
                                </div>
                              </a>
                              <div id="assignmentGroup_ao" class="dropdown-menu" aria-labelledby="assignmentGroup">
                                <div class="new">
                                  <div class="dropdown-body">
                                    <div class="
                                      d-flex
                                      justify-content-end
                                      iom-dropdown-search
                                    ">
                                      <div class="text-right mt-4">
                                        <a href="javascript:;" (click)="loadSupportGrpName('io')"
                                          class="btn btn-primary supportgrp-optnext" style="width: 7 rem">Select {{
                                          lstMappingConfig_io.FilterName }}</a>
                                      </div>
                                    </div>
                                    <div class="iom-dropdown-scroll">
                                      <div *ngIf="ioArr" class="
                                        row
                                        myw-grid
                                        row-cols-2 row-cols-lg-2
                                      ">
                                        <ng-container *ngFor="
                                          let d of ioArr;
                                          let i = index
                                        ">
                                          <div class="col" formArrayName="mappingConfigs" *ngIf="d.name != 'All'">
                                            <label class="my-width" title="{{d.fullName}}">
                                              <span>• {{ d.name }}</span>
                                            </label>
                                          </div>
                                        </ng-container>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2">
                          <div [ngClass]="{ disabled: !categorizedByFlag_io }" class="form-group">
                            <label class="form-label">Categorised by</label>
                            <select class="form-control" formControlName="categorisedBy">
                              <option value="">Select</option>
                              <option *ngFor="let t of lstCategorisedBy_io" [value]="t.name">
                                {{ t.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-5" *ngIf="envVar.EnableLanguage">
                          <div class="form-group iom-multiselect" [ngClass]="{ disabled: isDisabled == true }">
                            <label class="form-label myw-required">Ticket Language</label>
                            <ng-multiselect-dropdown formControlName="ddlMultiselect" class="form-control"
                              [placeholder]="'Select'" [(ngModel)]="selectedLanguage_IO" [data]="LanguageList"
                              [settings]="dropdownSettings" (enableCheckAll)="false"
                              (onSelect)="onItemSelect('LanguageIO',$event)"
                              (onSelectAll)="onItemSelectAll('LanguageIO',$event)"
                              (onDeSelect)="onItemDeSelect('LanguageIO',$event)"
                              (onDeSelectAll)="onItemDeSelectAll('LanguageIO',$event)">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2">
                          <div class="form-group">
                            <label class="myw-checkbox">
                              <input #DQTCheckboxIO id="DQTcheckboxIO" type="checkbox" [checked]="EnableDQTIO"
                                (change)="DQTCheckAdv(DQTCheckboxIO.checked,'IO')" name="data-qi">
                              <span>Data Quality Assessment</span>
                            </label>

                            <label class="myw-checkbox">
                              <input #LemmaCheckboxIO id="LemmaCheckboxIO" type="checkbox" [checked]="EnableLemmaIO"
                                [disabled]="LemmaDisableIO" (change)="LemmaCheckAdv(LemmaCheckboxIO.checked,'IO')"
                                name="data-qi">
                              <span>Lemmatization</span>
                            </label>
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="form-group">
                            <label class="form-label">Select Algorithm Model</label>
                            <div class="form-inline mt-2">
                              <label class="myw-checkbox myw-radio">
                                <input (click)="
                                    algorithmChange(
                                      true,
                                      'io',
                                      false,
                                      true,
                                      true,
                                      ''
                                    )
                                  " type="radio" value="2" formControlName="algorithmModel" checked />
                                <span>Auto Categorization (K-means)</span>
                              </label>
                              <label class="myw-checkbox myw-radio">
                                <input (click)="
                                    algorithmChange(
                                      false,
                                      'io',
                                      true,
                                      true,
                                      true,
                                      ''
                                    )
                                  " type="radio" value="1" formControlName="algorithmModel" />
                                <span>User Defined (N-gram)</span>
                              </label>
                              <label class="myw-checkbox myw-radio">
                                <input [attr.disabled]="
                                    check_language != 'English'
                                      ? 'disabled'
                                      : null
                                  " (click)="
                                    algorithmChange(
                                      false,
                                      'io',
                                      false,
                                      false,
                                      false,
                                      'regression'
                                    )
                                  " type="radio" value="3" formControlName="algorithmModel" />
                                <span>Logistic Regression</span>
                              </label>
                              <!-- <label class="myw-checkbox myw-radio disabled" *ngIf="this.check_language!='English'">
                                                                <input
                                                                    (click)="algorithmChange(false,'io', false, false, false,'regression')"
                                                                    type="radio" value="3"
                                                                    formControlName="algorithmModel" />
                                                                <span>Logistic Regression</span>
                                                            </label> -->
                            </div>
                          </div>
                        </div>
                        <div [ngClass]="{ disabled: !selectedAlgoOption_io }" *ngIf="this.required_io == false"
                          class="col-md-5">
                          <div class="form-group">
                            <label class="form-label">No of Cluster</label>
                            <input type="text" [readonly]="!selectedAlgoOption_io" formControlName="noOfCluster"
                              class="form-control" placeholder="Enter the Number of Cluster" />
                          </div>
                        </div>
                        <div [ngClass]="{ disabled: !selectedAlgoOption_io }" *ngIf="this.required_io == true"
                          class="col-md-5">
                          <div class="form-group">
                            <label class="form-label myw-required">No of Cluster</label>
                            <input type="text" [readonly]="!selectedAlgoOption_io" formControlName="noOfCluster"
                              class="form-control" placeholder="Enter the Number of Cluster" />
                          </div>
                        </div>
                        <!-- <div [ngClass]="{'disabled':!selectedAlgoOption_io}"
                                                    class="col-md-5 offset-md-2">
                                                    <div class="form-group">
                                                        <label class="form-label myw-required">Exit Criteria</label>
                                                        <input type="text" [readonly]="!selectedAlgoOption_io"
                                                            formControlName="exitCriteria" class="form-control"
                                                            placeholder="Enter the number of exit criteria" />
                                                    </div>
                                                </div> -->
                        <div [ngClass]="{ disabled: !selectedAlgoOption_io }" *ngIf="this.required_io == false"
                          class="col-md-5 offset-md-2" style="padding-left: 0px">
                          <div class="form-group">
                            <label class="form-label" style="width: 25rem">
                              Allow max % of unclassified tickets
                            </label>
                            <input type="text" [readonly]="!selectedAlgoOption_io" formControlName="exitCriteria"
                              class="form-control" placeholder="Enter allow max % of unclassified tickets" />
                          </div>
                        </div>
                        <div [ngClass]="{ disabled: !selectedAlgoOption_io }" *ngIf="this.required_io == true"
                          class="col-md-5 offset-md-2" style="padding-left: 0px">
                          <div class="form-group">
                            <label class="form-label myw-required" style="width: 25rem">
                              Allow max % of unclassified tickets
                            </label>
                            <input type="text" [readonly]="!selectedAlgoOption_io" formControlName="exitCriteria"
                              class="form-control" placeholder="Enter allow max % of unclassified tickets" />
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label class="form-label myw-required">Classified Based on</label>
                            <a href="javascript:;" class="btn btn-icon"
                              title="Please select an description field having min of 51 tickets with no null values."
                              style="cursor: pointer;">
                              <img src="assets/images/i-icon.svg" alt="Refresh" class="myw-icon myw-18">
                            </a>
                            <div class="form-inline mt-2">
                              <select class="form-control" formControlName="ClassifiedBased"
                                (change)="GetQualifiedDescriptionStandalone('IO')">
                                <option value="Select">Select</option>
                                <option *ngFor="let t of lstClassifiedBy_io" [value]="t.name">
                                  {{ t.name }}
                                </option>
                              </select>
                              <!-- <label class="myw-checkbox myw-radio">
                                <input (click)="
                                    ClassifiedBasedONChange(
                                      'ShortDescription',
                                      'IO'
                                    )
                                  " type="radio" value="ShortDescription" formControlName="classifiedBasedOn"
                                  checked />
                                <span>Short Description</span>
                              </label>
                              <label class="myw-checkbox myw-radio">
                                <input [attr.disabled]="
                                    !isResolutionDescEnabled_IO
                                      ? 'disabled'
                                      : null
                                  " (click)="
                                    ClassifiedBasedONChange(
                                      'ResolutionDescription',
                                      'IO'
                                    )
                                  " type="radio" value="ResolutionDescription" formControlName="classifiedBasedOn" />
                                <span>Resolution Description</span>
                              </label> -->
                              <div *ngIf="isAddkeywordsEnabled_IO" class="d-flex align-items-end ml-lg-auto mb-2">
                                Click here to&nbsp;<a href="javascript:;" (click)="getTopKeyWords('IO', true)"
                                  title="Get top keywords">
                                  Get top keywords</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="isAddkeywordsEnabled_IO && ChartData_IO" class="col-12">
                          <div class="iom-keyword">
                            <div class="
                                d-flex
                                align-items-end
                                justify-content-end
                                align-items-center
                              ">
                              <div class="form-inline mr-2">
                                <select class="form-control control-border" (change)="getTopKeyWords('IO', false)"
                                  formControlName="topWordOption">
                                  <option *ngFor="let t of WordCloudFilterOptions" [value]="t">
                                    Top {{ t }} words
                                  </option>
                                </select>
                              </div>
                              <!-- <a href="javascript:;" title="Minus"><img src="images/key-minus.svg" alt="Minus" class="myw-icon myw-40 mr-n2"></a>
                                                                <a href="javascript:;" title="Plus"><img src="images/key-plus.svg" alt="Plus" class="myw-icon myw-40"></a> -->
                            </div>
                            <div class="card-body" id="wordcloudContent">
                              <div id="containerwordCloud_IO">
                                <app-word-chart [ContainerId]="containerwordCloud_IO" [GraphData]="ChartData_IO"
                                  [wordlength]="1"></app-word-chart>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col" *ngIf="isAddkeywordsEnabled_IO">
                          <div class="form-group">
                            <label class="form-label">Add/Delete Stopwords</label>
                            <div class="form-group iom-multiselect">
                              <label>Language : </label>
                              <select class="form-control" style="width: 200px" [(ngModel)]='selectedStdLanguageIO' formControlName="ignorekeywordLanguage"
                                                  (change)="GetSelectedLanguage($event,'io')">
                                                  <option value="Select">Select</option>
                                                      <option *ngFor="let t of selectedLanguage_IO"
                                                          [value]="t">
                                                          {{t}}</option>
                                                  </select>
                           </div>
                            <input type="text" formControlName="ignorekeyword" class="form-control" name="ignoreword"
                              placeholder="Enter Keyword" />
                          </div>
                        </div>
                        <div class="col-auto d-flex align-items-end" *ngIf="isAddkeywordsEnabled_IO">
                          <div class="form-group">
                            <button type="button" (click)="addIgnoreKeyword('io')" class="btn btn-primary">
                              Add
                            </button>
                          </div>
                        </div>
                        <div class="col-12" *ngIf="isAddkeywordsEnabled_IO && enableBox_IO">
                          <div class="form-group mb-0">
                            <div rows="4">
                              <span class="tag-item" *ngFor="let word of lstIgnoreKeys_io" name="igonorew">
                                {{ word }}
                                <span class="remove-tag" (click)="RemoveKeyword(word, 'io')"
                                  style="cursor: pointer">×</span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Other -->
                    <div formGroupName="OthersGroup" class="tab-pane" id="other" role="tabpanel"
                      aria-labelledby="other-tab" [ngClass]="{ active: isLoadOtherPill }">
                      <div class="row iom-form">
                        <div class="col-md-5">
                          <div class="form-group">
                            <label class="form-label myw-required">Deepdive Name</label>
                            <input type="text" formControlName="deepdiveConfig" class="form-control"
                              placeholder="Enter Deepdive Name" />
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2">
                          <div class="form-group">
                            <label class="form-label myw-required">Ticket Type</label>
                            <select class="form-control" formControlName="ticketType"
                              (change)="getStopKeyWords('Others', $event, true)">
                              <option value="Select">Select</option>
                              <option *ngFor="let t of lstTicketType_others" [value]="t.TicketType">
                                {{ t.TicketType }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-5 iom-datepicker">
                          <div class="form-group">
                            <label class="form-label myw-required">Start Date</label>
                            <div class="input-group">
                              <input type="text" formControlName="startDate" class="form-control"
                                placeholder="Select Date" ngbDatepicker #d5="ngbDatepicker" onkeydown="return false"
                                (keyup.backspace)="
                                  onDateSelected('Others', $event)
                                " (dateSelect)="onDateSelected('Others', $event)" />
                              <div class="input-group-append">
                                <button (click)="d5.toggle()" class="btn" type="button">
                                  <img src="assets/images/cal.svg" alt="" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2 iom-datepicker">
                          <div class="form-group">
                            <label class="form-label myw-required">End Date</label>
                            <div class="input-group">
                              <input type="text" formControlName="endDate" class="form-control"
                                placeholder="Select Date" ngbDatepicker #d6="ngbDatepicker" onkeydown="return false"
                                (keyup.backspace)="
                                  onDateSelected('Others', $event)
                                " (dateSelect)="onDateSelected('Others', $event)" />
                              <div class="input-group-append">
                                <button (click)="d6.toggle()" class="btn" type="button">
                                  <img src="assets/images/cal.svg" alt="" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5">
                          <div class="form-group">
                            <label class="form-label myw-required">Select
                              {{ lstMappingConfig_others.FilterName }}</label>
                            <div class="iom-dropdown dropdown dropflat newoth">
                              <a href="javascript:;" (click)="ShowCheckboxPopup('others');" class="iom-dropdown-toggle"
                                role="button" title="{{ selectedSupportGroup_Others }}" id="assignmentGroup"
                                data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                                aria-expanded="false">
                                <div style="
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    color: #495057;
                                  ">
                                  {{ selectedSupportGroup_Others }}
                                </div>
                              </a>
                              <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                                <div class="new">
                                  <div class="dropdown-body">
                                    <div class="
                                      d-flex
                                      justify-content-end
                                      iom-dropdown-search
                                    ">
                                      <div class="text-right mt-4">
                                        <a href="javascript:;" (click)="loadSupportGrpName('others')"
                                          class="btn btn-primary supportgrp-optnext" style="width: 7 rem">Select {{
                                          lstMappingConfig_others.FilterName }}</a>
                                      </div>
                                    </div>
                                    <div class="iom-dropdown-scroll">
                                      <div *ngIf="othArr" class="
                                        row
                                        myw-grid
                                        row-cols-2 row-cols-lg-2
                                      ">
                                        <ng-container *ngFor="
                                          let d of othArr;
                                          let i = index
                                        ">
                                          <div class="col" formArrayName="mappingConfigs" *ngIf="d.name != 'All'">
                                            <label class="my-width" title="{{d.fullName}}">
                                              <span>• {{ d.name }}</span>
                                            </label>
                                          </div>
                                        </ng-container>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2">
                          <div [ngClass]="{ disabled: !categorizedByFlag_others }" class="form-group">
                            <label class="form-label">Categorised by</label>
                            <select class="form-control" formControlName="categorisedBy">
                              <option value="">Select</option>
                              <option *ngFor="let t of lstCategorisedBy_others" [value]="t.name">
                                {{ t.name }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="col-md-5" *ngIf="envVar.EnableLanguage">
                          <div class="form-group iom-multiselect" [ngClass]="{ disabled: isDisabled == true }">
                            <label class="form-label myw-required">Ticket Language</label>
                            <ng-multiselect-dropdown formControlName="ddlMultiselect" class="form-control" [placeholder]="'Select'" [(ngModel)]="selectedLanguage_Other"
                            [data]="LanguageList" [settings]="dropdownSettings"
                            (enableCheckAll)="false" 
                            (onSelect)="onItemSelect('LanguageOther',$event)"
                            (onSelectAll)="onItemSelectAll('LanguageOther',$event)"
                            (onDeSelect)="onItemDeSelect('LanguageOther',$event)"
                            (onDeSelectAll)="onItemDeSelectAll('LanguageOther',$event)">
                      </ng-multiselect-dropdown>
                          </div>
                        </div>
                        <div class="col-md-5 offset-md-2">
                          <div class="form-group">
                            <label class="myw-checkbox">
                              <input #DQTCheckboxOth id="DQTCheckboxOth" type="checkbox" [checked]="EnableDQTOth"
                                (change)="DQTCheckAdv(DQTCheckboxOth.checked,'Oth')" name="data-qo">
                              <span>Data Quality Assessment</span>
                            </label>

                            <label class="myw-checkbox">
                              <input #LemmaCheckboxOth id="LemmaCheckboxOth" type="checkbox" [checked]="EnableLemmaOth"
                                [disabled]="LemmaDisableOth" (change)="LemmaCheckAdv(LemmaCheckboxOth.checked,'Oth')"
                                name="data-qo">
                              <span>Lemmatization</span>
                            </label>
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="form-group">
                            <label class="form-label">Select Algorithm Model</label>
                            <div class="form-inline mt-2">
                              <label class="myw-checkbox myw-radio">
                                <input (click)="
                                    algorithmChange(
                                      true,
                                      'others',
                                      false,
                                      true,
                                      true,
                                      ''
                                    )
                                  " type="radio" value="2" formControlName="algorithmModel" checked />
                                <span>Auto Categorization (K-means)</span>
                              </label>
                              <label class="myw-checkbox myw-radio">
                                <input (click)="
                                    algorithmChange(
                                      false,
                                      'others',
                                      true,
                                      true,
                                      true,
                                      ''
                                    )
                                  " type="radio" value="1" formControlName="algorithmModel" />
                                <span>User Defined (N-gram)</span>
                              </label>
                              <!--<label class="myw-checkbox myw-radio">
                                                                <input
                                                                    (click)="algorithmChange(false,'others', false, true, true)"
                                                                    type="radio" value="4"
                                                                    formControlName="algorithmModel" />
                                                                <span>SAP Classification</span>
                                                            </label>-->
                            </div>
                          </div>
                        </div>
                        <div [ngClass]="{ disabled: !selectedAlgoOption_others }" *ngIf="this.required_others == false"
                          class="col-md-5">
                          <div class="form-group">
                            <label class="form-label">No of Cluster</label>
                            <input type="text" [readonly]="!selectedAlgoOption_others" formControlName="noOfCluster"
                              class="form-control" placeholder="Enter the Number of Cluster" />
                          </div>
                        </div>
                        <div [ngClass]="{ disabled: !selectedAlgoOption_others }" *ngIf="this.required_others == true"
                          class="col-md-5">
                          <div class="form-group">
                            <label class="form-label myw-required">No of Cluster</label>
                            <input type="text" [readonly]="!selectedAlgoOption_others" formControlName="noOfCluster"
                              class="form-control" placeholder="Enter the Number of Cluster" />
                          </div>
                        </div>
                        <!-- <div [ngClass]="{'disabled':!selectedAlgoOption_others}"
                                                    class="col-md-5 offset-md-2">
                                                    <div class="form-group">
                                                        <label class="form-label myw-required">Exit Criteria</label>
                                                        <input type="text" [readonly]="!selectedAlgoOption_others"
                                                            formControlName="exitCriteria" class="form-control"
                                                            placeholder="Enter the number of exit criteria" />
                                                    </div>
                                                </div> -->
                        <div [ngClass]="{ disabled: !selectedAlgoOption_others }" *ngIf="this.required_others == false"
                          class="col-md-5 offset-md-2" style="padding-left: 0px">
                          <div class="form-group">
                            <label class="form-label" style="width: 25rem">
                              Allow max % of unclassified tickets
                            </label>
                            <input type="text" [readonly]="!selectedAlgoOption_others" formControlName="exitCriteria"
                              class="form-control" placeholder="Enter allow max % of unclassified tickets" />
                          </div>
                        </div>
                        <div [ngClass]="{ disabled: !selectedAlgoOption_others }" *ngIf="this.required_others == true"
                          class="col-md-5 offset-md-2" style="padding-left: 0px">
                          <div class="form-group">
                            <label class="form-label myw-required" style="width: 25rem">
                              Allow max % of unclassified tickets
                            </label>
                            <input type="text" [readonly]="!selectedAlgoOption_others" formControlName="exitCriteria"
                              class="form-control" placeholder="Enter allow max % of unclassified tickets" />
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label class="form-label myw-required">Classified Based on</label>
                            <a href="javascript:;" class="btn btn-icon"
                              title="Please select an description field having min of 51 tickets with no null values."
                              style="cursor: pointer;">
                              <img src="assets/images/i-icon.svg" alt="Refresh" class="myw-icon myw-18">
                            </a>
                            <div class="form-inline mt-2">
                              <select class="form-control" formControlName="ClassifiedBased"
                                (change)="GetQualifiedDescriptionStandalone('OTHERS')">
                                <option value="Select">Select</option>
                                <option *ngFor="let t of lstClassifiedBy_others" [value]="t.name">
                                  {{ t.name }}
                                </option>
                              </select>
                              <!-- <label class="myw-checkbox myw-radio">
                                <input (click)="
                                    ClassifiedBasedONChange(
                                      'ShortDescription',
                                      'Others'
                                    )
                                  " type="radio" value="ShortDescription" formControlName="classifiedBasedOn"
                                  checked />
                                <span>Short Description</span>
                              </label>
                              <label class="myw-checkbox myw-radio">
                                <input [attr.disabled]="
                                    !isResolutionDescEnabled_Others
                                      ? 'disabled'
                                      : null
                                  " (click)="
                                    ClassifiedBasedONChange(
                                      'ResolutionDescription',
                                      'Others'
                                    )
                                  " type="radio" value="ResolutionDescription" formControlName="classifiedBasedOn" />
                                <span>Resolution Description</span>
                              </label> -->
                              <div class="d-flex align-items-end ml-lg-auto mb-2">
                                Click here to&nbsp;<a href="javascript:;" (click)="getTopKeyWords('Others', true)"
                                  title="Get top keywords">
                                  Get top keywords</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="ChartData_Others" class="col-12">
                          <div class="iom-keyword">
                            <div class="
                                d-flex
                                align-items-end
                                justify-content-end
                                align-items-center
                              ">
                              <div class="form-inline mr-2">
                                <select class="form-control control-border" (change)="getTopKeyWords('Others', false)"
                                  formControlName="topWordOption">
                                  <option *ngFor="let t of WordCloudFilterOptions" [value]="t">
                                    Top {{ t }} words
                                  </option>
                                </select>
                              </div>
                              <!-- <a href="javascript:;" title="Minus"><img src="images/key-minus.svg" alt="Minus" class="myw-icon myw-40 mr-n2"></a>
                                                                <a href="javascript:;" title="Plus"><img src="images/key-plus.svg" alt="Plus" class="myw-icon myw-40"></a> -->
                            </div>
                            <div class="card-body" id="wordcloudContent">
                              <div id="containerwordCloud_Others">
                                <app-word-chart [ContainerId]="containerwordCloud_Others" [GraphData]="ChartData_Others"
                                  [wordlength]="1"></app-word-chart>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col" *ngIf="isAddkeywordsEnabled_Others">
                          <div class="form-group">
                            <label class="form-label">Add/Delete Stopwords</label>
                            <div class="form-group iom-multiselect">
                              <label>Language : </label>
                              <select class="form-control" style="width: 200px" [(ngModel)]='selectedStdLanguageOthers' formControlName="ignorekeywordLanguage"
                                                  (change)="GetSelectedLanguage($event,'others')">
                                                  <option value="Select">Select</option>
                                                      <option *ngFor="let t of selectedLanguage_Other"
                                                          [value]="t">
                                                          {{t}}</option>
                                                  </select>
                            </div>
                            <input type="text" formControlName="ignorekeyword" class="form-control" name="ignoreword"
                              placeholder="Enter Keyword" />
                          </div>
                        </div>
                        <div class="col-auto d-flex align-items-end" *ngIf="isAddkeywordsEnabled_Others">
                          <div class="form-group">
                            <button type="button" (click)="addIgnoreKeyword('others')" class="btn btn-primary">
                              Add
                            </button>
                          </div>
                        </div>
                        <div class="col-12" *ngIf="
                            isAddkeywordsEnabled_Others && enableBox_Others
                          ">
                          <div class="form-group mb-0">
                            <div rows="4">
                              <span class="tag-item" *ngFor="let word of lstIgnoreKeys_others" name="igonorew">
                                {{ word }}
                                <span class="remove-tag" (click)="RemoveKeyword(word, 'others')"
                                  style="cursor: pointer">×</span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-right my-4">
                    <!-- <a class="btn btn-primary link" (click)="navigateToDeepDive()" style="cursor: pointer;">Create
                            Deepdive</a> -->
                    <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3"
                      (click)="CancelTicketUpload()" style="cursor: pointer; width: 10%">
                      Cancel
                    </button>
                    <button type="submit" class="btn btn-primary" style="cursor: pointer; width: 10%">
                      Create
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="enableSearch" class="suportgrp-section">
            <label class="form-label mb-3">Select {{ lstMappingConfig_ao.FilterName }} </label>
            <div *ngIf="enableSearchAO">
              <form autocomplete="off" *ngIf="isDataAvailable" [formGroup]="textConfigForm">
                <div formGroupName="AOGroup" class="tab-pane show active" id="apps" role="tabpanel"
                  aria-labelledby="apps-tab" [ngClass]="{ active: isLoadAoPill }">
                  <div class="col-12" style="height:auto;">
                    <div class="form-group">
                      <div>
                        <input (keyup)="searchAssignment('ao')" id="txtSearchAO" formControlName="searchText"
                          type="text" class="form-control control-border" placeholder="Search {{
                                  lstMappingConfig_ao.FilterName
                                }}" />
                      </div>
                      <div class="iom-dropdown-scroll">
                        <div class="fs-16 form-inline mt-2">
                          <label class="myw-checkbox">
                            <input id="selectAllConfigAO" type="checkbox" #selectedAllAoId
                              (change)="selectAllConfig('ao')" formControlName="selectAllConfig"
                              [attr.disabled]="this.textConfigForm.value.AOGroup.searchText != '' ? '' : null" />
                            <span>ALL</span>
                          </label>
                          <label class="myw-checkbox">
                            <input id="selectAllSearchAO" type="checkbox" #selectedSearchAllAoId
                              (change)="selectAllSearchConfig('ao')" formControlName="selectAllSearchConfig"
                              [attr.disabled]="this.textConfigForm.value.AOGroup.searchText == '' || this.lstFilterMappingConfig_aoSearch == null ? '' : null" />
                            <span style="left: 120px;">Select ALL with searched text
                              "{{this.textConfigForm.value.AOGroup.searchText}}" </span>
                          </label>
                        </div>
                        <div *ngIf="lstFilterMappingConfig_ao" class="
                                row
                                myw-grid
                                row-cols-4 row-cols-lg-4
                              ">
                          <ng-container *ngFor="
                                  let d of lstFilterMappingConfig_ao;   
                                  let i = index                             
                                ">
                            <div class="col" formArrayName="mappingConfigs" *ngIf="d.name != 'All'">
                              <label class="myw-checkbox my-width">
                                <input [attr.id]="'aoSearch_' + d.indexNo" type="checkbox"
                                  (change)="selectConfigSearch('ao',d.name)" value="d.name" [formControlName]="i" />
                                <span>{{ d.name }}</span>
                              </label>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                      <div class="text-right mt-4">
                        <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3"
                          (click)="ClearAllvalues('ao')" [ngClass]="{'disabled': !isClearAll}"> Clear All </button>
                        <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3"
                          (click)="CancelSearch('ao')"> Cancel </button>
                        <a href="javascript:;" (click)="ApplyChanges('ao')" [ngClass]="{'disabled': !enableApply}"
                          class="btn btn-primary supportgrp-optapply" style="width: 7 rem">Apply</a>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div *ngIf="enableSearchIO">
              <form autocomplete="off" *ngIf="isDataAvailable" [formGroup]="textConfigForm">
                <div formGroupName="IOGroup" class="tab-pane show active" id="apps" role="tabpanel"
                  aria-labelledby="apps-tab" [ngClass]="{ active: isLoadIoPill }">
                  <div class="col-12" style="height:auto;">
                    <div class="form-group">
                      <div>
                        <input (keyup)="searchAssignment('io')" id="txtSearchIO" formControlName="searchText"
                          type="text" class="form-control control-border" placeholder="Search {{
                                lstMappingConfig_io.FilterName
                              }}" />
                      </div>
                      <div class="iom-dropdown-scroll">
                        <div class="fs-16 form-inline mt-2">
                          <label class="myw-checkbox">
                            <input id="selectAllConfigIO" type="checkbox" #selectedAllIoId
                              (change)="selectAllConfig('io')" formControlName="selectAllConfig"
                              [attr.disabled]="this.textConfigForm.value.IOGroup.searchText != '' ? '' : null" />
                            <span>ALL</span>
                          </label>
                          <label class="myw-checkbox">
                            <input id="selectAllSearchIO" type="checkbox" #selectedSearchAllIoId
                              (change)="selectAllSearchConfig('io')" formControlName="selectAllSearchConfig"
                              [attr.disabled]="this.textConfigForm.value.IOGroup.searchText == '' || this.lstFilterMappingConfig_ioSearch == null ? '' : null" />
                            <span style="left: 120px;">Select ALL with searched text
                              "{{this.textConfigForm.value.IOGroup.searchText}}"</span>
                          </label>
                        </div>
                        <div *ngIf="lstFilterMappingConfig_io" class="
                              row
                              myw-grid
                              row-cols-4 row-cols-lg-4
                            ">
                          <ng-container *ngFor="
                                let d of lstFilterMappingConfig_io;   
                                let i = index                             
                              ">
                            <div class="col" formArrayName="mappingConfigs" *ngIf="d.name != 'All'">
                              <label class="myw-checkbox my-width">
                                <input [attr.id]="'ioSearch_' + d.indexNo" type="checkbox"
                                  (change)="selectConfigSearch('io',d.name)" value="d.name" [formControlName]="i" />
                                <span>{{ d.name }}</span>
                              </label>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                      <div class="text-right mt-4">
                        <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3"
                          (click)="ClearAllvalues('io')" [ngClass]="{'disabled': !isClearAll}"> Clear All </button>
                        <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3"
                          (click)="CancelSearch('io')"> Cancel </button>
                        <a href="javascript:;" (click)="ApplyChanges('io')" [ngClass]="{'disabled': !enableApply}"
                          class="btn btn-primary supportgrp-optapply" style="width: 7 rem">Apply</a>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div *ngIf="enableSearchOth">
              <form autocomplete="off" *ngIf="isDataAvailable" [formGroup]="textConfigForm">
                <div formGroupName="OthersGroup" class="tab-pane show active" id="apps" role="tabpanel"
                  aria-labelledby="apps-tab" [ngClass]="{ active: isLoadAoPill }">
                  <div class="col-12" style="height:auto;">
                    <div class="form-group">
                      <div>
                        <input (keyup)="searchAssignment('others')" id="txtSearchOth" formControlName="searchText"
                          type="text" class="form-control control-border" placeholder="Search {{
                                lstFilterMappingConfig_others.FilterName
                              }}" />
                      </div>
                      <div class="iom-dropdown-scroll">
                        <div class="fs-16 form-inline mt-2">
                          <label class="myw-checkbox">
                            <input id="selectAllConfigOth" type="checkbox" #selectedAllOthersId
                              (change)="selectAllConfig('others')" formControlName="selectAllConfig"
                              [attr.disabled]="this.textConfigForm.value.OthersGroup.searchText != '' ? '' : null" />
                            <span>ALL</span>
                          </label>
                          <label class="myw-checkbox">
                            <input id="selectAllSearchOth" type="checkbox" #selectedSearchAllOthersId
                              (change)="selectAllSearchConfig('others')" formControlName="selectAllSearchConfig"
                              [attr.disabled]="this.textConfigForm.value.OthersGroup.searchText == '' || this.lstFilterMappingConfig_othSearch == null ? '' : null" />
                            <span style="left: 120px;">Select ALL with searched text
                              "{{this.textConfigForm.value.OthersGroup.searchText}}"</span>
                          </label>
                        </div>
                        <div *ngIf="lstFilterMappingConfig_others" class="
                              row
                              myw-grid
                              row-cols-4 row-cols-lg-4
                            ">
                          <ng-container *ngFor="
                                let d of lstFilterMappingConfig_others;   
                                let i = index                             
                              ">
                            <div class="col" formArrayName="mappingConfigs" *ngIf="d.name != 'All'">
                              <label class="myw-checkbox my-width">
                                <input [attr.id]="'othSearch_' + d.indexNo" type="checkbox"
                                  (change)="selectConfigSearch('others',d.name)" value="d.name" [formControlName]="i" />
                                <span>{{ d.name }}</span>
                              </label>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                      <div class="text-right mt-4">
                        <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3"
                          (click)="ClearAllvalues('others')" [ngClass]="{'disabled': !isClearAll}"> Clear All </button>
                        <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3"
                          (click)="CancelSearch('others')"> Cancel </button>
                        <a href="javascript:;" (click)="ApplyChanges('others')" [ngClass]="{'disabled': !enableApply}"
                          class="btn btn-primary supportgrp-optapply" style="width: 7 rem">Apply</a>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /modal - Advance Options -->
</div>